import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiArrowRight
} from 'react-icons/fi';
import '../styles/Contacto.css';
import portadaImg from '../assets/images/portada.webp';

const Contacto = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <div className="contact-page-container" ref={containerRef}>
      <motion.div
        className="contact-background-image"
        style={{
          backgroundImage: `url(${portadaImg})`,
          y: parallaxY
        }}
      />

      <div className="contact-main-content">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <h1>Estamos para ayudarte</h1>
          <p>Comunícate con nosotros a través de los siguientes canales.</p>
        </motion.div>

        <motion.div
          className="contact-cards-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ staggerChildren: 0.2, delayChildren: 0.3 }}
        >
          {/* Card de Dirección */}
          <motion.div
            className="contact-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <div className="card-icon-wrapper">
              <FiMapPin className="card-icon" />
            </div>
            <h3 className="card-title">Nuestra Oficina</h3>
            <p className="card-description">
              Tucumán 1668 Piso 2 (C1050AAH)<br />
              CABA - Argentina
            </p>
            <a href="https://www.google.com/maps/place/Tucum%C3%A1n+1668,+C1050AAB+CABA,+Argentina" target="_blank" rel="noopener noreferrer" className="card-link">
              Ver en mapa <FiArrowRight />
            </a>
          </motion.div>

          {/* Card de Teléfono */}
          <motion.div
            className="contact-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: "easeOut", delay: 0.15 }}
          >
            <div className="card-icon-wrapper">
              <FiPhone className="card-icon" />
            </div>
            <h3 className="card-title">Teléfonos</h3>
            <p className="card-description">
              (54-11) 5256-5093<br />
              (54-11) 5275-5080
            </p>
            <a href="tel:+541152565093" className="card-link">
              Llamar ahora <FiArrowRight />
            </a>
          </motion.div>

          {/* Card de Email */}
          <motion.div
            className="contact-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}
          >
            <div className="card-icon-wrapper">
              <FiMail className="card-icon" />
            </div>
            <h3 className="card-title">Correo Electrónico</h3>
            <p className="card-description">
              Envíanos tu consulta a nuestra dirección de correo oficial.
            </p>
            <a href="mailto:caes@caes.com.ar" className="card-link">
              Enviar email <FiArrowRight />
            </a>
          </motion.div>
        </motion.div>

        {/* Mapa de Ubicación */}
        <motion.div
          className="map-container"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.024147772609!2d-58.39017268477024!3d-34.60354898045958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccaea5b803661%3A0x1c23493f01353ff3!2sTucum%C3%A1n%201668%2C%20C1050AAB%20CABA%2C%20Argentina!5e0!3m2!1ses-419!2sus!4v1663102120012!5m2!1ses-419!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa de ubicación de CAES"
          ></iframe>
        </motion.div>
      </div>
    </div>
  );
};

export default Contacto;